import { Col, Row } from 'react-grid-system'
import { AddressFormControlled } from './AddressFormControlled'
import { Button } from '../atoms'
import { useNavigate } from 'react-router'
import styled from 'styled-components'
import textsData from '@/textData/PropertyUpdateFormTexts.json'
import { useErrorHandlerContext, useOpeningElementsControllerContext, usePropertyDetailContext, useUserLanguage } from '@/customHooks'
import {
  FileOriginOption,
  FileTypeOption,
  PropertyTypeOption,
  UpdatePropertyInput,
  useGetFileUploadUrlsMutation,
  useUpdatePropertyMutation
} from '@/graphql/generated'
import { memo, useEffect, useState, useRef, useCallback } from 'react'
import { SquareButton2 } from '../atoms';
import { ImageUploader, VideoUploader } from '../molecules';

const StyledForm = styled.div`
  background-color: ${({ theme }) => theme.colors.light};
  padding: 2rem;
  margin-top: 1rem;
`

const SectionWrapper = styled.div`
  border-radius: ${({ theme }) => theme.border.radius.base};
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.border};
  border-width: 1px;
  padding: 2rem;
  margin-top: 1.5rem;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 1.5rem;
  & > span {
    background-color: ${({ theme }) => theme.colors.light};
    position: absolute;
    padding-left: 1rem;
    padding-right: 1rem;
    top: -1.3rem;
    line-height: 0;
  }
`

//////////////////////////////


type ButtonInfoProps = {
  icon: string
  text: string
  value: PropertyTypeOption
}

type SquareButtonsCardProps = {
  onSelected: (value: PropertyTypeOption) => void
  buttons: ButtonInfoProps[]
  defaultSelected?: PropertyTypeOption
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;
  gap: 3rem;
`

const SquareButtonsCard = memo(({ onSelected, buttons, defaultSelected }: SquareButtonsCardProps) => {
  const [selecteduButton, setSelectedButton] = useState<PropertyTypeOption | undefined>(defaultSelected)

  const onSelectHandle = (propertyType: PropertyTypeOption) => {
    setSelectedButton(propertyType)
    onSelected(propertyType)
  }

  return (
    <Wrapper>
      {buttons.map((btn, index) => (
        <SquareButton2
          key={btn.value + index}
          action={() => {
            onSelectHandle(btn.value)
          }}
          selected={selecteduButton === btn.value}
        >
          <>
            <img src={btn.icon} alt={btn.text} />
            <span>{btn.text}</span>
          </>
        </SquareButton2>
      ))}
    </Wrapper>
  );
})

///////////////////////////////////////////////
import BuildingIcon from '@/assets/property-icons/building-icon.svg';
import CityIcon from '@/assets/property-icons/city-icon.svg';
import HouseIcon from '@/assets/property-icons/house-icon.svg';
import HousesIcon from '@/assets/property-icons/houses-icon.svg';
import TownhouseIcon from '@/assets/property-icons/townhouse-icon.svg';
import { NormalFormTextField } from '../molecules';
import { capitalizeFirstLetter, propertyTypeMapper } from "@/helpers"

type BasicPropertyDataProps = {
  name: string,
  propertyType: PropertyTypeOption,
  ownerName: string
}

type BasicPropertyInfoProps = {
  onChange: ({ name, propertyType }: BasicPropertyDataProps) => void,
  defaultData?: BasicPropertyDataProps
}

/* TODO: Date: 260121: Este componente esta anulado debido a que en este momento no se necesita, se sacó esta feature de seleccionar si una property se renta completa o parcial
type GeneralPropertyDataProps = {
  isForRentWhole: boolean
}
type GeneralPropertyInfoProps = {
  onChange: ({ isForRentWhole }: GeneralPropertyDataProps) => void,
  defaultData?: GeneralPropertyDataProps
}
*/
const PropertyNameAndTypeForm = ({ onChange, defaultData }: BasicPropertyInfoProps) => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const dataRef = useRef<BasicPropertyDataProps>(defaultData || {
    name: '',
    propertyType: PropertyTypeOption.Other,
    ownerName: ''
  })

  const buttons = [
    { text: propertyTypeMapper(PropertyTypeOption.Unique, userLanguage), icon: HouseIcon, value: PropertyTypeOption.Unique },
    { text: propertyTypeMapper(PropertyTypeOption.MultiFamily, userLanguage), icon: HousesIcon, value: PropertyTypeOption.MultiFamily },
    { text: propertyTypeMapper(PropertyTypeOption.Apartment, userLanguage), icon: BuildingIcon, value: PropertyTypeOption.Apartment },
    { text: propertyTypeMapper(PropertyTypeOption.TownHouse, userLanguage), icon: TownhouseIcon, value: PropertyTypeOption.TownHouse },
    { text: propertyTypeMapper(PropertyTypeOption.Other, userLanguage), icon: CityIcon, value: PropertyTypeOption.Other },
  ];

  const onFieldChangeHandle = (field: keyof BasicPropertyDataProps, value: string | PropertyTypeOption) => {
    dataRef.current = {
      ...dataRef.current,
      [field]: value
    }

    onChange(dataRef.current)
  }

  useEffect(() => {
    if (defaultData) dataRef.current = defaultData
  }, [defaultData])

  return (
    <div>
      <Row>
        <Col>
          <NormalFormTextField
            label={texts.basicInformation.name}
            onChange={(value) => onFieldChangeHandle('name', value || '')}
            value={defaultData?.name}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <NormalFormTextField
            label={texts.basicInformation.ownerName}
            value={defaultData?.ownerName}
            readOnly
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <h4>{texts.basicInformation.propertytype}</h4>
        </Col>
        <Col xs={12}>
          <SquareButtonsCard
            buttons={buttons}
            onSelected={(value) => onFieldChangeHandle('propertyType', value)}
            defaultSelected={defaultData?.propertyType}
          />
        </Col>
      </Row>
    </div>
  );
};
/* TODO: Date: 260121: Este componente esta anulado debido a que en este momento no se necesita, se sacó esta feature de seleccionar si una property se renta completa o parcial
const GeneralOptionsForm = ({ onChange, defaultData }: GeneralPropertyInfoProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const [rentMode, setRentMode] = useState<'forRentWhole' | 'forRentPartial'>('forRentWhole')

  const buttons: { text: string, icon: string, value: 'forRentWhole' | 'forRentPartial' }[] = [
    { text: texts.generalOptions.rentModeOptions.forRentWhole, icon: HouseIcon, value: 'forRentWhole' },
    { text: texts.generalOptions.rentModeOptions.forRentPartial, icon: HouseIcon, value: 'forRentPartial' },
  ];

  useEffect(() => {
    if (defaultData) setRentMode(defaultData.isForRentWhole ? 'forRentWhole' : 'forRentPartial')
  }, [defaultData])

  useEffect(() => {
    onChange({ isForRentWhole: rentMode === 'forRentWhole' })
  }, [rentMode])

  return (
    <div>
      <Row justify='start'>
        <Col xs='content'>
          <span>{texts.generalOptions.rentMode}</span>
        </Col>
        <Col>
          <Wrapper>
            {buttons.map((btn, index) => (
              <SquareButton2
                key={btn.value + index}
                action={() => {
                  setRentMode(btn.value)
                }}
                selected={rentMode === btn.value}
              >
                <>
                  <img src={btn.icon} alt={btn.text} />
                  <span>{btn.text}</span>
                </>
              </SquareButton2>
            ))}
          </Wrapper>
        </Col>
      </Row>
    </div>
  );
};
 */
export const PropertyUpdateForm = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const { property, setProperty } = usePropertyDetailContext()

  const updatePropertyInputRef = useRef<UpdatePropertyInput>({
    name: property?.name,
    propertyTypeOption: property?.typeOption,
    ownerId: property?.owner?.user.id,
    street: property?.address.street,
    buildingNumber: property?.address.buildingNumber,
    addressLine: property?.address.addressLine,
    cityId: property?.address.city?.geonamesId ?? '',
    stateId: property?.address.state?.geonamesAdmin1Code ?? '',
    countryId: property?.address.country?.iso2 ?? '',
    zipCode: property?.address.zipCode,
  })

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()
  const { open: errorHandle } = useErrorHandlerContext()

  const [picturesState, setPictures] = useState<File[]>([])
  const [videosState, setVideos] = useState<File[]>([])
  const [isUploadingMedia, setIsUploadingMedia] = useState(false)

  const [getUploadUrls] = useGetFileUploadUrlsMutation()

  const [updateProperty, { loading }] = useUpdatePropertyMutation()

  const handleSubmit = useCallback(async () => {
    try {
      let uploadedFilesIds: string[] = []

      if (picturesState.length > 0 || videosState.length > 0) {
        setIsUploadingMedia(true)

        if (picturesState.length > 0) {
          const getUploadUrlsResponse = await getUploadUrls({
            variables: {
              inputs: picturesState.map((picture) => ({
                contentType: picture.type,
                fileExtension: 'webp',
                fileTypeOption: FileTypeOption.Picture,
                fileOriginOption: FileOriginOption.Property,
                fileSize: picture.size.toString(),
              })),
            },
          })

          const uploadDataList = getUploadUrlsResponse.data?.getUploadUrls
          if (!uploadDataList || uploadDataList.length !== picturesState.length) {
            throw new Error('No se pudieron obtener las URLs para subir las imágenes.')
          }

          const uploadPromises = uploadDataList.map((uploadData, index) => {
            const uploadUrl = uploadData.uploadUrl ?? ''
            return fetch(uploadUrl, {
              method: 'PUT',
              body: picturesState[index],
              headers: { 'Content-Type': picturesState[index].type },
            })
          })

          await Promise.all(uploadPromises)
          uploadedFilesIds = uploadedFilesIds.concat(uploadDataList.map(uploadData => uploadData.id))
        }

        if (videosState.length > 0) {
          const getUploadUrlsResponse = await getUploadUrls({
            variables: {
              inputs: videosState.map((video) => ({
                contentType: 'video/mp4',
                fileExtension: 'mp4',
                fileTypeOption: FileTypeOption.Video,
                fileOriginOption: FileOriginOption.Property,
                fileSize: video.size.toString(),
              })),
            },
          })

          const uploadDataList = getUploadUrlsResponse.data?.getUploadUrls
          if (!uploadDataList || uploadDataList.length !== videosState.length) {
            throw new Error('No se pudieron obtener las URLs para subir los videos.')
          }

          const uploadPromises = uploadDataList.map((uploadData, index) => {
            const uploadUrl = uploadData.uploadUrl ?? ''
            return fetch(uploadUrl, {
              method: 'PUT',
              body: videosState[index],
              headers: { 'Content-Type': 'video/mp4' },
            })
          })

          await Promise.all(uploadPromises)
          uploadedFilesIds = uploadedFilesIds.concat(uploadDataList.map(uploadData => uploadData.id))
        }
      }

      let input: UpdatePropertyInput

      if (uploadedFilesIds.length > 0) {
        input = {
          uploadedFilesIds,
        }
      } else {
        input = {
          name: updatePropertyInputRef.current.name || '',
          propertyTypeOption: updatePropertyInputRef.current.propertyTypeOption,
          ownerId: updatePropertyInputRef.current.ownerId || '',
          street: updatePropertyInputRef.current.street || '',
          buildingNumber: updatePropertyInputRef.current.buildingNumber || '',
          addressLine: updatePropertyInputRef.current.addressLine || '',
          cityId: updatePropertyInputRef.current.cityId || '',
          stateId: updatePropertyInputRef.current.stateId || '',
          countryId: updatePropertyInputRef.current.countryId || '',
          zipCode: updatePropertyInputRef.current.zipCode || '',
        }
      }
      const response = await updateProperty({
        variables: {
          input,
          propertyId: property?.id ?? '',
        },
      })

      confirmDialogModalOpen({
        title: texts.form.successMessage.title,
        description: `${response.data?.updateProperty.name} ${texts.form.successMessage.description}`,
      })
      setProperty(undefined) //Force property context change to force a refetch
    } catch (error) {
      errorHandle(error as any)
    } finally {
      setIsUploadingMedia(false)
    }
  }, [
    confirmDialogModalOpen,
    errorHandle,
    getUploadUrls,
    picturesState,
    videosState,
    property?.id,
    texts.form.successMessage.description,
    texts.form.successMessage.title,
    updateProperty,
  ])

  const navigate = useNavigate()

  return (
    <StyledForm>
      <SectionWrapper>
        <span><h2>{texts.form.title}</h2></span>
        <PropertyNameAndTypeForm
          onChange={(data) => {
            updatePropertyInputRef.current.name = data.name
            updatePropertyInputRef.current.propertyTypeOption = data.propertyType
          }}
          defaultData={
            property
              ? (
                {
                  name: capitalizeFirstLetter(property.name || ''),
                  propertyType: property.typeOption,
                  ownerName: property.owner
                    ? capitalizeFirstLetter(`${property.owner.firstName} ${property.owner.lastName}`)
                    : ''
                }
              )
              : undefined
          }
        />
      </SectionWrapper>
      <SectionWrapper>
        <span><h2>{texts.generalOptions.title}</h2></span>
        <ImageUploader onUploadReady={setPictures} />
        <VideoUploader onUploadReady={setVideos} />
      </SectionWrapper>
      <br />
      <SectionWrapper>
        <span><h2>{texts.address.title}</h2></span>
        <AddressFormControlled
          onChange={(address) => {
            Object.assign(updatePropertyInputRef.current, {
              street: address.street,
              buildingNumber: address.buildingNumber,
              addressLine: address.addressLine,
              cityId: address.city,
              stateId: address.state,
              countryId: address.country,
              zipCode: address.zipCode,
            })
          }}
          defaultAddress={{
            street: property?.address.street ?? '',
            buildingNumber: property?.address.buildingNumber ?? '',
            addressLine: property?.address.addressLine ?? '',
            country: property?.address.country?.iso2 ?? '',
            state: property?.address.state?.geonamesAdmin1Code ?? '',
            city: property?.address.city?.geonamesId ?? '',
            zipCode: property?.address.zipCode ?? '',
          }}
        />
      </SectionWrapper>
      <br />
      <Row justify="center">
        <Col xs="content">
          <Button secondary onClick={() => navigate(-1)}>{texts.form.cancelButton}</Button>
        </Col>
        <Col xs="content">
          <Button
            onClick={handleSubmit}
            isLoading={loading || isUploadingMedia}
          >{texts.form.confirmButton}</Button>
        </Col>
      </Row>
    </StyledForm>
  )
}
